module.exports = __webpack_public_path__ + "img/announcement-01.1c6bfa46.svg";